import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import * as actionTypes from 'appRedux/actions/taxInvoice/settingsActionType';
import * as actionCreators from 'appRedux/actions/taxInvoice/settingsActions';
import { userSignOut } from 'appRedux/actions/Auth';
import { API_URL_V1, API_PMS_HEADERS } from 'constants/ApiSetting';
import { APIPostRequest } from 'util/connection';
import { getItems } from 'util/localStorage';

function* taxInvoiceSettingsRequestProcess({ payload }: actionTypes.TaxInvoiceSettingsRequestAction): Generator<any, void, any> {
  try {
    // ดึง token จาก localStorage
    const { access_token } = yield call(getItems, ['access_token']);

    if (!access_token) {
      console.error('Tax Invoice Settings API: Access token is missing');
      yield put(actionCreators.taxInvoiceSettingsError('Authentication token is missing. Please login again.'));
      return;
    }

    // ใช้ API URL สำหรับ get_settings
    const url = `${API_URL_V1}pms/rpc/interface/get_settings`;

    // ใช้ API_PMS_HEADERS ตาม pattern ของ sagas อื่นๆ
    API_PMS_HEADERS.headers.Authorization = `Bearer ${access_token}`;

    const response: any = yield call(APIPostRequest, url, payload, API_PMS_HEADERS);

    // ตรวจสอบ response structure
    const responseData = response?.data || response;
    const hasResultCode = responseData?.result_code !== undefined;
    const hasResultData = responseData?.result_data !== undefined;
    const resultCode = responseData?.result_code;

    // ตรวจสอบว่า response มี status หรือไม่
    const isSuccess = (response?.status === 200 || !response?.status) && resultCode === '0';

    if (isSuccess && hasResultCode && hasResultData) {
      // สร้าง SettingsResponse structure
      const settingsResponse: actionTypes.TaxInvoiceSettingsResponse = {
        result_code: responseData.result_code,
        result_msg: responseData.result_msg || 'Success',
        msg_code: responseData.msg_code || '00',
        result_data: responseData.result_data,
      };

      yield put(actionCreators.taxInvoiceSettingsSuccess({
        data: settingsResponse,
        status: response?.status || 200,
        message: response?.message || 'OK',
      }));
    } else {
      // Error case
      const errorMessage = responseData?.result_msg || response?.message || 'Failed to fetch tax invoice settings';

      yield put(actionCreators.taxInvoiceSettingsError(errorMessage));

      if (response?.status === 403) {
        // Force signout if unauthorized or already logged out
        const responseDataForError = response?.data || response;
        const errorMsg = responseDataForError?.result_msg || response?.message || errorMessage;
        const errorData = responseDataForError?.data;

        const isAlreadyLoggedOut =
          errorMsg === 'Already logged out' ||
          errorMsg === 'Invalid token, authentication required' ||
          errorData === null ||
          errorData === undefined;

        // Signout if already logged out or if data exists (unauthorized)
        if (isAlreadyLoggedOut || errorData) {
          yield put(userSignOut());
        }
      }
    }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
    yield put(actionCreators.taxInvoiceSettingsError(errorMessage, error));
  }
}

function* taxInvoiceSettingsRequest() {
  yield takeEvery(actionTypes.TAX_INVOICE_SETTINGS_REQUEST, taxInvoiceSettingsRequestProcess);
}

export default function* rootSaga() {
  yield all([fork(taxInvoiceSettingsRequest)]);
}

